export const getSourceType = (source) => {
  let ret = '';
  if (source.includes('.mp3')) {
    ret = 'audio/mp3';
  } else if (source.includes('.mp4')) {
    ret = 'video/mp4';
  } else if (source.includes('.m3u8')) {
    ret = 'application/x-mpegURL';
  }
  return ret;
};

export const getSourceLabel = (source) => {
  const ret = {};
  if (source.includes('f0.m3u8')) {
    ret.label = '原画';
    ret.res = 360;
  } else if (source.includes('f240.m3u8')) {
    ret.label = '超清';
    ret.res = 1080;
  } else if (source.includes('f230.m3u8')) {
    ret.label = '高清';
    ret.res = 720;
  } else if (source.includes('f220.m3u8')) {
    ret.label = '标清';
    ret.res = 480;
  } else if (source.includes('.f0.mp4')) {
    ret.label = '原画';
    ret.res = 360;
  } else if (source.includes('.f40.mp4') || source.includes('/40.mp4')) {
    ret.label = '超清';
    ret.res = 1080;
  } else if (source.includes('.f30.mp4') || source.includes('/30.mp4')) {
    ret.label = '高清';
    ret.res = 720;
  } else if (source.includes('.f20.mp4') || source.includes('/20.mp4')) {
    ret.label = '标清';
    ret.res = 480;
  }
  return ret;
};
